const toggleBlockquote = (editor) => {
  editor.chain().focus().toggleBlockquote().run();
};

export default {
  'blockquote:toggle': toggleBlockquote,
};
